import { render, staticRenderFns } from "./QuoteTable.vue?vue&type=template&id=5daae2ad&scoped=true&lang=html&"
import script from "./QuoteTable.vue?vue&type=script&lang=js&"
export * from "./QuoteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daae2ad",
  null
  
)

export default component.exports